import cx from 'classnames';

import { ITextInputProps } from './types';

export const TextInput = ({
  value,
  maxLength,
  onChange,
  placeholder,
  leftIcon,
  rightIcon,
  className,
  autoComplete,
}: ITextInputProps) => {
  return (
    <div className="flex flex-1 relative items-center">
      {leftIcon && <div className="absolute left-4">{leftIcon}</div>}

      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder ?? undefined}
        maxLength={maxLength}
        autoComplete={autoComplete}
        className={cx(className, 'h-[48px]', {
          'pr-12': !!leftIcon,
          'pl-12': !!rightIcon,
        })}
      />

      {rightIcon && <div className="absolute right-4">{rightIcon}</div>}
    </div>
  );
};
